import {
  buildFilledVosFormV2Pdf,
  type VosFormV2Appointment,
} from './fillVosFormV2Pdf'
import {downloadPdfBlob, mergeVosPdfWithCustomerDocuments} from './mergeVosPdfAttachments'

type CustomerDocument = {path?: string | null}

export type ExportManualVosPdfOptions = {
  appointment: Record<string, unknown>
  fileName: string
  watermarkText?: string
  customerDocuments?: CustomerDocument[]
  appBaseUrl?: string
}

/** Download pre-filled vos_form_v2.pdf (official template) with optional customer-doc merge. */
export async function exportManualVosPdf(options: ExportManualVosPdfOptions): Promise<void> {
  const {appointment, fileName, watermarkText, customerDocuments = [], appBaseUrl} = options
  const normalizedName = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`

  const vosBytes = await buildFilledVosFormV2Pdf(
    appointment as VosFormV2Appointment,
    watermarkText
  )

  let finalBlob = new Blob([vosBytes], {type: 'application/pdf'})

  if (customerDocuments.length > 0) {
    finalBlob = await mergeVosPdfWithCustomerDocuments(
      vosBytes.buffer.slice(
        vosBytes.byteOffset,
        vosBytes.byteOffset + vosBytes.byteLength
      ) as ArrayBuffer,
      customerDocuments,
      appBaseUrl
    )
  }

  downloadPdfBlob(finalBlob, normalizedName)
}
